import useSWR from "swr";
import { apiUrls } from "../utils/apiUtils";
import { fetcher } from "../utils/fetcher";

interface UserApiResponse {
  data: User;
}

/**
 * Hook for authentication and user information
 * @returns Authentication state and user information
 */
export function useAuth() {
  // Check if token exists - if not, don't bother fetching
  const token = localStorage.getItem('token');

  const { data: user, error, mutate } = useSWR<UserApiResponse>(
    // Only fetch if token exists
    token ? apiUrls.userProfile() : null,
    fetcher,
    {
      revalidateOnFocus: false,
      shouldRetryOnError: false,
      dedupingInterval: 10000,
    }
  );

  // Not authenticated if no token
  if (!token) {
    return {
      user: undefined,
      isLoading: false,
      isError: null,
      mutate,
      isAuthenticated: false,
    };
  }

  return {
    user: user?.data,
    isLoading: !error && !user,
    isError: error,
    mutate,
    isAuthenticated: !!user?.data,
  };
}